import RsmbwfaktdbSlider from './RsmbwfaktdbSlider';
import { MEDIA_QUERIES } from '../../../javascripts/constants';

const mql = window.matchMedia(MEDIA_QUERIES.xxl);
let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];

  const config = {
    showDots: true,
    scrollContainerClass: '.rsmbwfaktdb-slider__inner',
    itemsContainerClass: '.rsmbwfaktdb-slider__items',
    itemClass: '.rsmbwfaktdb-slider__item',
    // itemsToScroll: 1,
    itemsVisible: 1,
    resizeVerticalImages: false,
    positionControlsOnImages: false,
  };
  document.querySelectorAll('.rsmbwfaktdb-slider').forEach(($slider) => {
    // Matze data attribute auslesen
    // const itemsToScrollM = $slider.dataset.itemsToScrollM;
    // const itemsToScrollXl = $slider.dataset.itemsToScrollXl;
    // const itemsToScrollXxl = $slider.dataset.itemsToScrollXxl;
    componentStore.push(
      new RsmbwfaktdbSlider($slider, mq, {
        ...config,
        // itemsToScroll: {
        //   m: itemsToScrollM,
        //   xl: itemsToScrollXl,
        //   xxl: itemsToScrollXxl,
        // },
      })
    );
  });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
